var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { DrawerThumbnailsList } from './DrawerThumbnailsList';
import { css } from '@emotion/css';
import { useUploadManager } from '../../UploadManagerProvider';
import { DrawerListSpinner } from './DrawerListSpinner';
import { CustomEventPropagationProvider } from '../../CustomEventPropagationProvider';
import { DrawerProvider } from './DrawerProvider';
import { useLocalization } from '../../Localization';
import { Typography } from '@vp/swan';
const drawerStyle = css `
    width: 100%;
    height: 100%;
`;
/**
 * A visual container for an infinitely scrolling list of user assets
 */
export const Drawer = observer((props) => {
    const { emptyResultsElement = _jsx(_Fragment, {}), onClick, onDoubleClick, onClickLogo, loadingSpinnerElement = _jsx(DrawerListSpinner, {}), errorElement = _jsx(_Fragment, {}), drawerListOptions: { showBrandKitLogos = false, showRecentlyUploaded = true, showRecentlyUploadedLabel = false, } = {} } = props, rest = __rest(props, ["emptyResultsElement", "onClick", "onDoubleClick", "onClickLogo", "loadingSpinnerElement", "errorElement", "drawerListOptions"]);
    const { visibleAssets, fetchingStatus, canFetchMore, visibleLogoAssets } = useUploadManager();
    const [Announcement, setAnnouncement] = useState('');
    const { loadingMoreAssetsLabel, loadingMoreAssetsFinishedLabel, recentlyUploadedLabel, brandLogosLabel } = useLocalization();
    useEffect(() => {
        if (fetchingStatus === 'loading-more') {
            setAnnouncement(loadingMoreAssetsLabel || 'Loading more assets...');
            return;
        }
        if (fetchingStatus === 'ready') {
            setAnnouncement(loadingMoreAssetsFinishedLabel || 'Loading more assets is finished');
            return;
        }
        setAnnouncement('');
    }, [fetchingStatus, loadingMoreAssetsFinishedLabel, loadingMoreAssetsLabel]);
    if (fetchingStatus === 'error') {
        return errorElement;
    }
    if (fetchingStatus === 'loading-more' || fetchingStatus === 'ready') {
        // assets can be hidden after they are loaded in the store
        if (visibleAssets.length === 0 && !canFetchMore) {
            return emptyResultsElement;
        }
        return (_jsx(DrawerProvider, Object.assign({}, rest, { children: _jsx(CustomEventPropagationProvider, Object.assign({ name: "uploads_drawer" }, { children: _jsxs("div", Object.assign({ className: drawerStyle, "data-testid": "drawer" }, { children: [_jsx("div", Object.assign({ "aria-live": "polite", className: "swan-visually-hidden" }, { children: Announcement })), showBrandKitLogos && !!(visibleLogoAssets === null || visibleLogoAssets === void 0 ? void 0 : visibleLogoAssets.length) && (_jsxs(_Fragment, { children: [!!brandLogosLabel && (_jsx(Typography, Object.assign({ fontSkin: "body-small-bold", mb: '3', mt: '4', textColor: "subtle" }, { children: brandLogosLabel }))), _jsx(DrawerThumbnailsList, { assets: visibleLogoAssets, onClick: onClickLogo, onDoubleClick: onDoubleClick, hasRemoveBtn: false })] })), showRecentlyUploaded && (_jsxs(_Fragment, { children: [showRecentlyUploadedLabel && !!recentlyUploadedLabel && !!visibleAssets.length && (_jsx(Typography, Object.assign({ fontSkin: "body-small-bold", mb: '3', mt: '4', textColor: "subtle" }, { children: recentlyUploadedLabel }))), _jsx(DrawerThumbnailsList, { assets: visibleAssets, onClick: onClick, onDoubleClick: onDoubleClick, hasRemoveBtn: props.deleteOption === 'none' ? false : true })] }))] })) })) })));
    }
    return loadingSpinnerElement;
});
Drawer.displayName = 'Drawer';
//# sourceMappingURL=Drawer.js.map